// Patient data transformer

import { BaseTransformer } from './BaseTransformer';

export class PatientTransformer extends BaseTransformer {
  
  async transform(patientData: Record<string, unknown>): Promise<Record<string, unknown>> {
    console.log(`[PATIENT-TRANSFORM] Applying mapping rules:`);
    console.log(`   • Name → first_name`);
    console.log(`   • Owner → family_name (last name extraction)`);
    console.log(`   • lID → location_id`);

    const ownerText = String(patientData.owner || '');
    const extractedLastName = this.extractLastName(ownerText);

    return this.pruneUndefined({
      id: patientData.id,
      name: patientData.name,
      first_name: patientData.name,
      family_name: extractedLastName,
      client: patientData.client,
      location_id: patientData.lID,
      owners: this.ensureArray(patientData.owners),
      groups: this.ensureArray(patientData.groups),
      image: patientData.image || 'pet-image-placeholder.png',
      archived: this.safeBoolean(patientData.archived),
      pinned: this.safeBoolean(patientData.pinned),
      created_at: patientData.createdAt || this.getCurrentTimestamp(),
      updated_at: this.getCurrentTimestamp()
    });
  }
} 